<template>
  <!-- eslint-disable -->
  <v-dialog v-model="dialog" persistent max-width="500px" content-class="user-edit-dialog">
    <v-toolbar style="background-color: #f5f5f5; height: unset;">
      <v-toolbar-title>
        <v-avatar large class="red">
          <span v-if="editMode" class="white--text headline">
            {{ editModel.UserName ? editModel.UserName.match(/\b(\w)/g)[0].toUpperCase() : ""}}
          </span>
          <span v-else class="white--text headline">
            {{ selectedUser.UserName ? selectedUser.UserName.match(/\b(\w)/g)[0].toUpperCase() : ""}}
          </span>
        </v-avatar>
      </v-toolbar-title>
      <v-toolbar-title>{{selectedUser.FirstName}} {{selectedUser.LastName}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items v-show="!editMode">
        <v-btn text class="edit-user-dialog-btn" icon @click="edit(selectedUser)">
          <v-icon small>edit</v-icon>
        </v-btn>
        <v-btn text class="close-dialog-btn" icon @click.native="cancel()">
          <v-icon small>close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card v-show="editMode" style="border-radius: 0;">
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field class="user-first-name-field" label="First Name" single-line v-model="editModel.FirstName" prepend-icon="account_box"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field class="user-last-name-field" label="Last Name" single-line v-model="editModel.LastName"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field class="user-email-field" label="Email" v-model="editModel.Email" single-line :rules="[rulesEmail, rulesRequired]" required prepend-icon="mail"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field class="user-username-field" ref="username" label="User Name" v-model="editModel.UserName" :error-messages="userNameError" validate-on-blur required :rules="[rulesRequired, rulesWhiteSpace, v => validateUserName(v) || 'UserName must be unique']" single-line @click:append="() => (setUsernameAsEmail())" append-icon="mail" prepend-icon="assignment_ind"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select class="user-clients-select" content-class="user-clients-list" :items="getValidClients()" @change="resetLocations" v-model="editClientId" prepend-icon="business" item-text="Name" item-value="Id" label="Client" single-line :rules="[rulesRequired]" required :append-icon="editModel.ClientId == null  ? '' : 'clear'" @click:append="() => (editModel.ClientId = null)"></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field class="user-phone-field" label="Phone" single-line v-model="editModel.PhoneNumber" :rules="[rulesPhone]" prepend-icon="phone"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select class="user-questions-select" content-class="user-questions-list" :items="questions" v-model="editModel.PasswordQuestion" prepend-icon="lock" label="Password Question" single-line required :rules="[rulesRequired]" :append-icon="editModel.TimeZone == null  ? '' : 'clear'" @click:append="() => (editModel.PasswordQuestion = null)"></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field class="user-password-field" label="Password Answer" single-line v-model="editModel.PasswordAnswer" prepend-icon="lock_open" required :rules="[rulesRequired]"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select class="user-timezone-select" content-class="user-timezone-list" :items="timeZones" v-model="editModel.TimeZone" prepend-icon="query_builder" label="Time Zone" single-line :append-icon="editModel.TimeZone == null  ? '' : 'clear'" @click:append="() => (editModel.TimeZone = null)"></v-select>
              </v-flex>
              <v-flex xs6>
                <v-checkbox label="Reset Password" v-model="resetPassword" />
              </v-flex>
              <v-flex xs6 v-show="resetPassword">
                <v-radio-group v-model="editModel.SendEmail">
                  <v-radio label="No Email" value=""></v-radio>
                  <v-radio label="Send Welcome Email" value="WELCOME"></v-radio>
                  <v-radio label="Send Reset Email" value="RESET"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 v-show="resetPassword">
                <v-text-field label="Password" single-line v-model="editModel.Password" prepend-icon="lock" :append-icon="passVisible ? 'visibility' : 'visibility_off'" @click:append="() => (passVisible = !passVisible)" :type="passVisible ? 'text' : 'password'"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-form>
    </v-card>
    <v-card v-show="!editMode" style="border-radius: 0;">
      <v-card-title>
        <h5 class="title">User Details</h5>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md text-xs-center>
          <v-layout row wrap>
            <v-flex xs3>
              <v-icon>assignment_ind</v-icon>
            </v-flex>
            <v-flex class="text-xs-left" xs9>
              {{selectedUser.UserName}}
            </v-flex>
            <v-flex xs3>
              <v-icon>mail</v-icon>
            </v-flex>
            <v-flex class="text-xs-left" xs9>
              {{selectedUser.Email}}
            </v-flex>
            <v-flex xs3>
              <v-icon>business</v-icon>
            </v-flex>
            <v-flex class="text-xs-left" xs9>
              {{selectedUser.ClientName}}
            </v-flex>
            <v-flex xs3>
              <v-icon>contact_mail</v-icon>
            </v-flex>
            <v-flex class="text-xs-left" xs9>
              <a mailto="">{{selectedUser.Email}}</a>
            </v-flex>
            <v-flex xs3>
              <v-icon>contact_phone</v-icon>
            </v-flex>
            <v-flex class="text-xs-left" xs9>
              {{selectedUser.PhoneNumber}}
            </v-flex>
            <v-flex xs3>
              <v-icon>query_builder</v-icon>
            </v-flex>
            <v-flex class="text-xs-left" xs9>
              {{selectedUser.TimeZone}}
            </v-flex>
            <v-flex xs3>
              <v-icon>lock</v-icon>
            </v-flex>
            <v-flex class="text-xs-left" xs9>
              {{selectedUser.PasswordQuestion}}
            </v-flex>
            <v-flex xs3>
              <v-icon>lock_open</v-icon>
            </v-flex>
            <v-flex class="text-xs-left" xs9>
              {{selectedUser.PasswordAnswer}}
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card  style="border-radius: 0;">
      <v-card-title style="display: block;">
        <h5 class="title" xs12>Location Assignment</h5>
        <h6 class="subheader">Define a user's access to locations and notification preferences</h6>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md text-xs-center pa-0 ma-0>
          <v-layout row wrap>
            <v-flex xs8 class="text-xs-left">
              <b>Location</b>
            </v-flex>
            <v-flex xs2>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">present_to_all</v-icon>
                </template>
                <span>Notify Of Escalations</span>
              </v-tooltip>
            </v-flex>
            <v-flex xs2>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">ac_unit</v-icon>
                </template>
                <span>Notify Of Calamities</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-for="loc in getLocations()" :key="loc.LocationId" class="location-edit-list">
            <v-flex xs8>
              <v-switch class="location-switch" v-if="editMode" :label="loc.Name" v-model="loc.Selected"></v-switch>
              <v-checkbox v-else v-model="loc.Selected" :label="loc.Name" disabled></v-checkbox>
            </v-flex>
            <v-flex xs2>
              <v-switch class="NotifyOnEscalation-switch" v-if="editMode" v-model="loc.NotifyOnEscalation" :disabled="!loc.Selected"></v-switch>
              <v-checkbox v-else v-model="loc.NotifyOnEscalation" disabled></v-checkbox>
            </v-flex>
            <v-flex xs2>
              <v-switch class="NotifyOnCalamity-switch" v-if="editMode" v-model="loc.NotifyOnCalamity" :disabled="!loc.Selected"></v-switch>
              <v-checkbox v-else v-model="loc.NotifyOnCalamity" disabled></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions v-show="editMode">
        <v-btn text color="primary" class="cancel-edit-btn" @click="cancelEdit()">Cancel</v-btn>
        <v-btn text color="primary" class="save-user-btn" :disabled="!valid" @click="save()">Save {{editModel.SendResetEmail ? " and Send" : ""}}</v-btn>
        <div class="error--text" v-if="!valid">Form Invalid Correct Errors Above</div>
      </v-card-actions>
    </v-card>
  </v-dialog>
<!-- eslint-enable -->
</template>
<script>
import { USERS_NAMESPACE } from "./store/userStore";
import { mapGetters } from "vuex";
import RulesMixin from "@/mixins/RulesMixin.js";
import UserDialogMixin from "@/mixins/UserDialogMixin.js";
export default {
  name: "UserDialog",
  mixins: [RulesMixin, UserDialogMixin],
  data() {
    return {
      editUserLocationModel: [],
      editClientId: null
    };
  },
  computed: {
    ...mapGetters(USERS_NAMESPACE, [
      "selectedUser",
      "users",
      "loading",
      "clients"
    ])
  },
  created: /* istanbul ignore next */ function() {
    this.USER_DIALOG_MIXIN_NAMESPACE = USERS_NAMESPACE;
    this.$parent.$on("userEdit", this.show);
  },
  methods: {
    cancelEdit() {
      if (this.editModel.Id) {
        this.editMode = false;
      } else {
        this.cancel();
      }
    },
    cancel() {
      this.$refs.form.reset();
      this.editModel = {};
      this.editMode = false;
      this.dialog = false;
      this.editUserLocationModel = [];
    },
    save() {
      if (this.$refs.form.validate()) {
        this.editModel.UserLocations = this.editUserLocationModel;
        this.$store
          .dispatch(`${USERS_NAMESPACE}/saveUser`, _.cloneDeep(this.editModel))
          .then(res => {
            this.cancel();
          });
      }
    },
    resetLocations(val) {
      if (val == null || val === this.editModel.ClientId) return;
      this.editModel.ClientId = val;
      var client = this.clients.find(x => {
        return x.Id === this.editModel.ClientId;
      });
      /* istanbul ignore else */
      if (client) {
        var items = client.Locations.map(x => {
          return {
            LocationId: x.Id,
            Name: x.Name,
            Selected: false,
            NotifyOnEscalation: false,
            NotifyOnCalamity: false
          };
        });
        this.editUserLocationModel = items;
        this.$forceUpdate();
      }
    },
    getValidClients(){
      var validClients = this.clients.filter(e => e.Id != 3);
      return validClients;
    },
    getLocations() {
      if (this.editMode) return this.editUserLocationModel;
      return this.selectedUser.UserLocations;
    },
    edit(user) {
      this.editModel = _.cloneDeep(user);
      this.editMode = true;
      this.editUserLocationModel = user.UserLocations;
      this.editClientId = this.editModel.ClientId;
      setTimeout(this.$refs.form.validate, 100);
    },
    show(mode) {
      this.dialog = true;
      if (mode === 1) {
        this.editMode = true;
      }
    }
  }
};
</script>
